import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SmoothScroll from "./components/SmoothScroll";
import CustomCursor from "./components/CustomCursor";
import Background3D from "./components/Background3D";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import PracticeSection from "./components/PracticeSection";
import VisionSection from "./components/VisionSection";
import Marquee from "./components/Marquee";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import Preloader from "./components/Preloader";

function Home() {
  return (
    <div className="relative" data-testid="home-root">
      <Preloader />
      <SmoothScroll />
      <CustomCursor />
      <Background3D />
      <div className="grain" />

      <div className="relative z-10">
        <Header />
        <main>
          <HeroSection />
          <AboutSection />
          <PracticeSection />
          <Marquee />
          <VisionSection />
          <ContactSection />
        </main>
        <Footer />
      </div>
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
